import { Directive, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { GridCell, RowCell, Section, ContentElement, ContentEnum, ContentElementEnum, ContentStatusEnum } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../section-builder-store.service';

@Directive({
  selector: '[ngxBaseStepper]'
})
export class BaseStepperDirective {
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;
 
  contentElements:ContentElement[];
 
  stepperTitle:string;
   lastStep = false;
   firstStep = true;
   showPlaceholder: boolean = true;
   baseUrl:string;
 
   imgSrc: string;
 
   contentEnum:ContentEnum;
   cntElementEnum = ContentElementEnum;
   currentCntElementEnum:ContentElementEnum;
 
   mode:string;
 
   @Output() closeHostDialog = new EventEmitter<void>()
 
   constructor(
     protected ofbizFormsService:OfbizFormsService,
     protected sectionBuilderStoreService:SectionBuilderStoreService,
     protected configurationService:ConfigurationService,
     ){}
 
   ngOnInit(): void {
     this.baseUrl = this.configurationService.getBaseUrl();
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     if(changes["cell"]){
       this.contentElements = this.cell.contentElements;
       this.contentEnum = this.cell.contentEnum;
       this.imgSrc = this.cell.imgSrc;
       this.stepperTitle = this.getStepperTitle(this.contentEnum)
     }
   }
 
   getStepperTitle(titleEnum){
     let title;
     if((titleEnum).includes(".")){
       let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
       title = ContentEnum[enumKey];
     }else if(ContentEnum[titleEnum] != undefined){
       title = ContentEnum[titleEnum]
     }else{
       title = titleEnum;
     }
     
     console.log(title)
     
     return title;
   }
 
   getImageSrc(fields:any[]):void{
     //let productId = this.getFieldValue("productId",fields);
   //console.log(productId);
   let smallImageUrl = this.getFieldValue("smallImageUrl",fields);
   if(smallImageUrl != undefined){
     //clean url of htmlsafe characters
     smallImageUrl = decodeURIComponent(smallImageUrl);
     let baseUrl = this.baseUrl.replace("rest/","");
     this.imgSrc = baseUrl+smallImageUrl;
     this.cell.imgSrc = this.imgSrc;
     this.showPlaceholder = false;
     console.log(this.imgSrc)
   }
   //console.log(this.cell)
   //get the productSummary
 }
 
 getFieldValue(nameKey, fields:any[]){
   let value;
     for (let i=0; i < fields.length; i++) {
       for (let [k,v] of Object.entries(fields[i])) {
         if(k == nameKey){
           //value =  fields[i][k];
           value = v
         }
       }
     }
   return value
 }
 
   onSubmitContent(){
     console.log("onSubmitContent",this.section)
     this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
     this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
     this.sectionBuilderStoreService.updateSection(this.section);
     this.sectionBuilderStoreService.updateSelectedCell(this.cell);
     this.closeHostDialog.emit();
   }

   onStepChange(e){
    if(e.index == (e.step.stepper.steps.length - 1)){
      this.lastStep = true;
    }
    if(e.index > 0){
      this.firstStep = false;
    }
  }

  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let titleEnum = contentElement.contentElementEnum
    if(titleEnum != undefined){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[titleEnum] != undefined){
        enumValue = ContentElementEnum[titleEnum]
      }else{
        enumValue = titleEnum;
      }
    }
    if(enumValue) enumValue = <string>enumValue.toUpperCase();
    
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

}
